module.exports = __webpack_public_path__ + "static/screenshot2@2x-f1c1ab38af64b711ce44ccebfe75b5b8.jpg";